import { SxProps, Theme } from "@mui/material";
import theme from "../../../../theme";

export const iconSx:SxProps<Theme> = {
  width: theme.spacing(20/8),
  height: theme.spacing(20/8),
  backgroundColor: "transparent"
}